import React from 'react';
import ReferencePointsPanel from './panels/ReferencePointsPanel';
import ToothDesignPanel from './panels/ToothDesignPanel';
import DrawingToolsPanel from './panels/DrawingToolsPanel';
import TemplatePanel from './panels/TemplatePanel';
import AiDesignPanel from './panels/AiDesignPanel';
import LayersPanel from './panels/LayersPanel';

const SmileDesignerSidebar = ({
  activeMode,
  activeTool,
  onToolChange,
  referencePoints,
  placingPoint,
  onStartPlacing,
  onClearPoint,
  designParams,
  onDesignParamsChange,
  onApplyPreset,
  onRegenerateTeeth,
  drawSettings,
  onDrawSettingsChange,
  selectedTemplateId,
  onApplyTemplate,
  fabricCanvas,
  onSaveState,
  // AI Design props
  selectedPhoto,
  onAiGenerate,
  aiResult,
  aiLoading,
  aiError,
  showComparison,
  onToggleComparison,
  generationsRemaining,
}) => {
  return (
    <div className="w-64 flex-shrink-0 bg-white border border-gray-200 rounded-lg overflow-y-auto" style={{ maxHeight: 'calc(100vh - 220px)' }}>
      <div className="p-3 space-y-5">
        {/* Reference Points - shown in overlay and template modes */}
        {(activeMode === 'overlay' || activeMode === 'template') && (
          <ReferencePointsPanel
            referencePoints={referencePoints}
            placingPoint={placingPoint}
            onStartPlacing={onStartPlacing}
            onClearPoint={onClearPoint}
          />
        )}

        {/* Tooth Design - shown in overlay mode */}
        {activeMode === 'overlay' && (
          <>
            <div className="border-t border-gray-100" />
            <ToothDesignPanel
              designParams={designParams}
              onDesignParamsChange={onDesignParamsChange}
              onApplyPreset={onApplyPreset}
              onRegenerateTeeth={onRegenerateTeeth}
              fabricCanvas={fabricCanvas}
              onSaveState={onSaveState}
            />
          </>
        )}

        {/* Drawing Tools - shown in mockup mode */}
        {activeMode === 'mockup' && (
          <DrawingToolsPanel
            activeTool={activeTool}
            onToolChange={onToolChange}
            drawSettings={drawSettings}
            onDrawSettingsChange={onDrawSettingsChange}
          />
        )}

        {/* Templates - shown in template mode */}
        {activeMode === 'template' && (
          <>
            <div className="border-t border-gray-100" />
            <TemplatePanel
              selectedTemplateId={selectedTemplateId}
              onApplyTemplate={onApplyTemplate}
              referencePoints={referencePoints}
            />
          </>
        )}

        {/* AI Design - shown in ai mode */}
        {activeMode === 'ai' && (
          <AiDesignPanel
            selectedPhoto={selectedPhoto}
            onGenerate={onAiGenerate}
            aiResult={aiResult}
            aiLoading={aiLoading}
            aiError={aiError}
            showComparison={showComparison}
            onToggleComparison={onToggleComparison}
            generationsRemaining={generationsRemaining}
          />
        )}

        {/* Layers - always shown (except AI mode where canvas isn't editable) */}
        {activeMode !== 'ai' && (
          <>
            <div className="border-t border-gray-100" />
            <LayersPanel
              fabricCanvas={fabricCanvas}
              onSaveState={onSaveState}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SmileDesignerSidebar;
